import React from "react";
import Moshkelats from "./Controllers/Moshkelats";
import InsertMoshkelatLayout from "./Layout/InsertMoshkelatLayout";

class   RoutingMoshkelat {

    constructor() {
        this.routes=[
           {
                key: "products",
                parentKey: "dashboard",
                breadcrumb: "مشکلات مردمی ",
                path: "/membership/moshkelats",
                main: () =><Moshkelats />,
                exact: true
            },
            {
                key: "insertMoshkelat",
                parentKey: "products",
                breadcrumb: "ثبت مشکلات مردمی",
                path: "/membership/moshkelat/insert",
                main: () =><InsertMoshkelatLayout />,
                exact: true
            },
        ];

    }

    get(){
        return this.routes;
    }
}

export default RoutingMoshkelat ;
